import { IonBackdrop } from '@ionic/react';
import React from 'react';

const Backdrop = () => {
  return (
    <IonBackdrop></IonBackdrop>
  );
};

export default Backdrop;